<template>
  <!-- <i :class="`icon icon-${type}`"></i> -->
  <icon-font :type="`iconicon-nav-${type}`" />
</template>

<script>
import { Icon } from 'ant-design-vue';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1081752_r250r35q9c7.js',
})
export default {
  components: {
    IconFont
  },
  props: {
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss">
</style>
